export const styles = {
  text: 'text-center',
};
